export const CHANGE_FONT_REQUESTED = "CHANGE_FONT_REQUESTED";
export const CHANGE_FONT = "CHANGE_FONT";

export const CHANGE_FONT_WEIGHT_REQUESTED = "CHANGE_FONT_WEIGHT_REQUESTED";
export const CHANGE_FONT_WEIGHT = "CHANGE_FONT_WEIGHT";

export const CHANGE_THEME_REQUESTED = "CHANGE_THEME_REQUESTED";
export const CHANGE_THEME = "CHANGE_THEME";

export const TOGGLE_LEFT_SIDEBAR_REQUESTED = "TOGGLE_LEFT_SIDEBAR_REQUESTED";
export const TOGGLE_LEFT_SIDEBAR = "TOGGLE_LEFT_SIDEBAR";

export const TOGGLE_RIGHT_SIDEBAR_REQUESTED = "TOGGLE_RIGHT_SIDEBAR_REQUESTED";
export const TOGGLE_RIGHT_SIDEBAR = "TOGGLE_RIGHT_SIDEBAR";

export const TOGGLE_FIXED_LEFT_SIDEBAR_REQUESTED =
  "TOGGLE_FIXED_LEFT_SIDEBAR_REQUESTED";
export const TOGGLE_FIXED_LEFT_SIDEBAR = "TOGGLE_FIXED_LEFT_SIDEBAR";

export const REQUEST_OPEN_LOCKSCREEN = "REQUEST_OPEN_LOCKSCREEN";
export const OPEN_LOCKSCREEN = "OPEN_LOCKSCREEN";
export const REQUEST_CLOSE_LOCKSCREEN = "REQUEST_CLOSE_LOCKSCREEN";
export const CLOSE_LOCKSCREEN = "CLOSE_LOCKSCREEN";
export const REQUEST_TOGGLE_LOCKSCREEN = "REQUEST_TOGGLE_LOCKSCREEN";

// ERROR ACTIONS
export const CHANGE_FONT_ERROR = "CHANGE_FONT_ERROR";
export const CHANGE_THEME_ERROR = "CHANGE_THEME_ERROR";
export const TOGGLE_RIGHT_SIDEBAR_ERROR = "TOGGLE_RIGHT_SIDEBAR_ERROR";
export const TOGGLE_LEFT_SIDEBAR_ERROR = "TOGGLE_LEFT_SIDEBAR_ERROR";
export const TOGGLE_FIXED_LEFT_SIDEBAR_ERROR =
  "TOGGLE_FIXED_LEFT_SIDEBAR_ERROR";
export const CHANGE_FONT_WEIGHT_ERROR = "CHANGE_FONT_WEIGHT_ERROR";
export const REQUEST_TOGGLE_LOCKSCREEN_ERROR =
  "REQUEST_TOGGLE_LOCKSCREEN_ERROR";
